import { z } from 'zod';

import { TripStatusSchema } from '@voll-intelligence/domain';

import { chatUiBase } from '../../shared/schema/base.js';
import { ChatUiTripVoucherSchema } from '../../shared/schema/trip_voucher_schema.js';

export const ChatUiTripSchema = z.object({
  tripId: z.string(),
  name: z.string().nullable(),
  status: TripStatusSchema.nullable(),
  origin: z.string().nullable(),
  destination: z.string().nullable(),
  startAt: z.string().nullable(),
  endAt: z.string().nullable(),
  startLocal: z.string().nullable().optional(),
  endLocal: z.string().nullable().optional(),
  modals: z.array(z.string()),
  totalAmount: z.number().nullable(),
  currency: z.string().nullable(),
  companyName: z.string().nullable().optional(),
  vouchers: z.array(ChatUiTripVoucherSchema),
});
export type ChatUiTrip = z.infer<typeof ChatUiTripSchema>;

/** Producer cap — bounds the SSE frame for a heavy traveler. */
export const CHAT_UI_MAX_TRIPS = 20;

/** Membro `trips` do `ChatUiSchema` (discriminatedUnion). */
export const TripsBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('trips'),
    trips: z.array(ChatUiTripSchema).max(CHAT_UI_MAX_TRIPS),
  })
  .strict();
